module.exports = __webpack_public_path__ + "static/media/tip-goal-active.71d2c510.svg";